import { type ComponentProps } from "react";
import type { Icon } from "@tabler/icons-react";
import ButtonCard from "../../UI/ButtonCard";
import FeaturedIcon from "../../UI/FeaturedIcon";
import { type IconColor } from "../../UI/IconColors";
import Text from "../../UI/Text";
import styles from "./ChoiceCard.module.css";

interface ChoiceCardProps extends ComponentProps<typeof ButtonCard> {
  icon: Icon;
  title: string;
  subtitle: string;
  iconColor?: IconColor;
}

export default function ChoiceCard({
  icon,
  title,
  subtitle,
  iconColor = "primary",
  className,
  ...props
}: ChoiceCardProps) {
  return (
    <ButtonCard className={className} {...props}>
      <div className={styles.content}>
        <FeaturedIcon icon={icon} size="lg" shape="square" color={iconColor} />
        <div>
          <Text weight="bold">{title}</Text>
          <Text color="muted">{subtitle}</Text>
        </div>
      </div>
    </ButtonCard>
  );
}
